:host {
  display: block;
  width: 100%;
  height: 100%;
}

.img_container {
  width: 100%;
  height: 100%;
  position: relative;

  &.height-auto {
    height: auto;
  }

  &.add-to-cart {
    img {
      object-fit: contain;
    }
  }
}

img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img_info {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 9px;
  font-family: var(--primary-font);
  color: white;

  p {
    padding: 5px 10px;
    margin: 0;
  }

  width: fit-content;
  height: fit-content;
  z-index: 2;

  &::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: black;
    opacity: 0.5;
    z-index: -1;
  }
}
